import type { ProjectSchema } from '@readme/backend/models/project/types';

/**
 * Determines whether a project has any custom code configured (CSS, JS, or HTML).
 * Used on both the server (to decide whether to sandbox Hub content) and the
 * client (to decide whether to render an iframe).
 */
export function hasCustomCode(project: Pick<ProjectSchema, 'appearance'> | undefined): boolean {
  if (!project?.appearance) return false;

  return [
    project.appearance.stylesheet_hub2,
    project.appearance.javascript_hub2,
    project.appearance.html_head,
    project.appearance.html_footer,
    project.appearance.html_footer_meta,
  ].some(code => typeof code === 'string' && !!code.trim().length);
}

export function hasUnsafeIntegrations(
  project: Pick<ProjectSchema, 'intercom' | 'localize' | 'zendesk'> | undefined,
): boolean {
  if (!project) return false;

  return [project.intercom, project.localize, project.zendesk].some(
    val => typeof val === 'string' && !!val.trim().length,
  );
}
